import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Disclaimer.css';

const IconWrapper = ({ children, size = 20, style, className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginRight: '10px', verticalAlign: 'middle', flexShrink: 0, ...style }}
    className={className}
    aria-hidden="true"
  >
    {children}
  </svg>
);

const ICONS = {
  SHIELD_ALERT: (
    <IconWrapper>
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </IconWrapper>
  ),
  BRIEFCASE: (
    <IconWrapper>
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </IconWrapper>
  ),
  GOVERNMENT: (
    <IconWrapper>
      <line x1="3" y1="22" x2="21" y2="22" />
      <line x1="6" y1="18" x2="6" y2="11" />
      <line x1="10" y1="18" x2="10" y2="11" />
      <line x1="14" y1="18" x2="14" y2="11" />
      <line x1="18" y1="18" x2="18" y2="11" />
      <polygon points="12 2 20 7 4 7" />
    </IconWrapper>
  ),
  PROHIBITED: (
    <IconWrapper>
      <circle cx="12" cy="12" r="10" />
      <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
    </IconWrapper>
  ),
  USERS: (
    <IconWrapper>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </IconWrapper>
  ),
  FILE_TEXT: (
    <IconWrapper>
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14 2 14 8 20 8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10 9 9 9 8 9" />
    </IconWrapper>
  ),
  LINK: (
    <IconWrapper>
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </IconWrapper>
  ),
  SCALE: (
    <IconWrapper>
      <path d="m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
      <path d="m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z" />
      <path d="M7 21h10" />
      <path d="M12 3v18" />
      <path d="M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2" />
    </IconWrapper>
  ),
  CONTACT: (
    <IconWrapper>
      <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
    </IconWrapper>
  ),
  ARROW_UP: (
    <IconWrapper size={20} style={{ marginRight: 0 }}>
      <line x1="12" y1="19" x2="12" y2="5" />
      <polyline points="5 12 12 5 19 12" />
    </IconWrapper>
  ),
  SEARCH: (
    <IconWrapper size={18} style={{ marginRight: '8px' }} className="disclaimer-page-search-icon">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </IconWrapper>
  )
};

const officialAddress = "Mani Casadona, IT/ITES Business Hub, New Town, Rajarhat, Kolkata, West Bengal – 700161, India";
const officialPhone = "+91 90383 20103";
const officialEmail = "nutrivioheadoffice@gmail.com";
const lastUpdatedDate = "5 Jan 2026";

const rawSections = [
  {
    id: 'independent-advisory-status',
    num: "01",
    title: 'Independent Professional Advisory Status',
    icon: ICONS.BRIEFCASE,
    content: `
      <p><strong>Nutrivio Medical Services Private Limited</strong> (&ldquo;Nutrivio&rdquo;) operates strictly as an independent <strong>Medical Education Institutional Advisory & Professional Services Company</strong>.</p>
      <p>All institutional planning, gap assessments, hospital readiness reviews, documentation assistance, and academic staffing services are rendered strictly in an independent advisory capacity under mutually executed contractual terms with client institutions, societies, and trusts.</p>
      <div class="disclaimer-page-callout-box">
        <p><strong>Non-Governmental Entity Notice:</strong> Nutrivio is a private corporate advisory entity and is <strong>not an agency, subsidiary, regulatory arm, or authorized representative of the National Medical Commission (NMC), Ministry of Health & Family Welfare (MoHFW), Medical Counselling Committee (MCC), or any State Medical Council / Affiliating University</strong>.</p>
      </div>
    `
  },
  {
    id: 'no-guarantee-of-approvals',
    num: "02",
    title: 'No Guaranteed Regulatory Approvals or Sanctions',
    icon: ICONS.GOVERNMENT,
    content: `
      <p>Nutrivio provides structured institutional guidance, gap analysis, and documentation coordination designed to support an institution's self-preparedness. However, <strong>no statutory permission, Letter of Intent (LOI), Letter of Permission (LOP), seat expansion, or renewal is ever represented or implied as guaranteed</strong>.</p>
      <p>All final decisions, inspections, compliance assessments, seat approvals, and course sanctionings rest solely with the competent statutory bodies, including:</p>
      <ul>
        <li><strong>National Medical Commission (NMC)</strong> and its autonomous boards (MARB, UGMEB, PGMEB).</li>
        <li><strong>Ministry of Health & Family Welfare (MoHFW)</strong>, Government of India.</li>
        <li><strong>Concerned State Governments & Directorate of Medical Education (DME)</strong> (for Essentiality Certificates).</li>
        <li><strong>Affiliating Health Science Universities</strong> (for University Affiliation and Consent of Affiliation).</li>
      </ul>
      <p>Nutrivio does not exercise influence, discretion, or authority over statutory evaluations or regulatory assessment results.</p>
    `
  },
  {
    id: 'prohibited-claims-framework',
    num: "03",
    title: 'Positioning Language & Representation Framework',
    icon: ICONS.PROHIBITED,
    content: `
      <p>In accordance with corporate governance standards and professional service transparency, Nutrivio enforces a strict representation framework across all public communications and stakeholder engagements:</p>
      
      <div class="disclaimer-page-comparison-grid">
        <div class="disclaimer-page-comparison-card positive">
          <div class="disclaimer-page-comparison-badge positive">Approved Positioning Scope</div>
          <ul>
            <li>Strategic Institutional Advisory & Feasibility Studies</li>
            <li>Department-wise & Hospital Gap Identification</li>
            <li>Academic & Clinical Documentation Coordination</li>
            <li>Institutional Preparedness & Self-Assessment Planning</li>
            <li>Permanent & Full-Time Medical Faculty Recruitment</li>
          </ul>
        </div>
        <div class="disclaimer-page-comparison-card negative">
          <div class="disclaimer-page-comparison-badge negative">Explicitly Prohibited Claims</div>
          <ul>
            <li>No "100% Guaranteed Approval / Guaranteed LOP" claims</li>
            <li>No "NMC Authorized / Approved Consultant" claims</li>
            <li>No "India's No. 1 / Best Ranked" unverified assertions</li>
            <li>No "Guaranteed Faculty Availability or Inspection Clearance"</li>
            <li>No representation of liaison services with public officers</li>
          </ul>
        </div>
      </div>
    `
  },
  {
    id: 'faculty-recruitment-disclaimer',
    num: "04",
    title: 'Permanent Faculty Recruitment Disclaimer',
    icon: ICONS.USERS,
    content: `
      <p>Nutrivio provides professional recruitment coordination to Medical Colleges and Teaching Hospitals for <strong>genuine Permanent & Full-Time academic appointments</strong> across Pre-Clinical, Para-Clinical, and Clinical disciplines.</p>
      <ul>
        <li><strong>Verification Responsibility:</strong> While Nutrivio undertakes preliminary qualification and experience document screening, the ultimate verification of registration authenticity, biometric verification (AEBAS), degree validations, and statutory eligibility rests with the appointing institution and competent regulatory authorities.</li>
        <li><strong>Independent Candidate Choice:</strong> Faculty placement is subject to candidate availability, voluntary acceptance of employment terms, and formal institutional interviews. Nutrivio does not guarantee candidate retention or tenure beyond agreed contractual terms.</li>
        <li><strong>No Temporary or Proxy Arrangements:</strong> Nutrivio explicitly refuses and opposes any participation in temporary, non-genuine, or surrogate faculty arrangements.</li>
      </ul>
    `
  },
  {
    id: 'informational-nature-of-content',
    num: "05",
    title: 'Website Content & Informational Use',
    icon: ICONS.FILE_TEXT,
    content: `
      <p>All editorial content, service descriptions, timelines, frameworks, and insights published on this website are provided for <strong>general informational and institutional guidance purposes only</strong>.</p>
      <p>While we make every effort to maintain accurate, up-to-date information reflecting prevailing regulatory norms (such as NMC Minimum Standard Requirements), statutory guidelines are subject to frequent regulatory updates, public gazettes, and judicial pronouncements. Promoters and institutions must rely on official gazette notifications and customized advisory scopes for specific legal and infrastructural decisions.</p>
    `
  },
  {
    id: 'limitation-of-liability',
    num: "06",
    title: 'Limitation of Corporate Liability',
    icon: ICONS.SCALE,
    content: `
      <p>To the fullest extent permitted by applicable Indian law, Nutrivio Medical Services Private Limited, its Directors, advisors, employees, and affiliates shall not be liable for:</p>
      <ul>
        <li>Any direct, indirect, incidental, consequential, or punitive damages arising from the use of, or inability to use, this website or reliance upon its general materials.</li>
        <li>Regulatory rejection, delay, denial, or modification of statutory approvals, permits, or seat allocations by regulatory authorities.</li>
        <li>Institutional decisions, civil construction investments, hospital acquisitions, or financial outlays undertaken prior to or outside of formal, executed professional advisory contracts.</li>
      </ul>
    `
  },
  {
    id: 'third-party-links',
    num: "07",
    title: 'External References & Third-Party Portals',
    icon: ICONS.LINK,
    content: `
      <p>This website may contain references or hyperlinks to statutory portals, university websites, or industry publications for reference purposes (e.g., NMC, MoHFW portals). Nutrivio does not control, endorse, or assume responsibility for the accuracy, uptime, or privacy standards of external websites.</p>
    `
  },
  {
    id: 'corporate-contact',
    num: "08",
    title: 'Institutional Governance & Corporate Desk',
    icon: ICONS.CONTACT,
    content: `
      <p>If you require written clarifications regarding our professional advisory scope, terms of institutional engagement, or compliance standards, please reach out to our corporate headquarters:</p>
      <p><strong>NUTRIVIO MEDICAL SERVICES PRIVATE LIMITED</strong></p>
      <address class="disclaimer-page-address">
        <strong>Registered & Corporate Desk:</strong><br>
        ${officialAddress}
      </address>
      <p><strong>Phone:</strong> <a href="tel:+919038320103" class="disclaimer-page-link">${officialPhone}</a></p>
      <p><strong>WhatsApp Desk:</strong> <a href="https://wa.me/919038320103" target="_blank" rel="noopener noreferrer" class="disclaimer-page-link">${officialPhone}</a></p>
      <p><strong>Official Email:</strong> <a href="mailto:${officialEmail}" class="disclaimer-page-link">${officialEmail}</a></p>
      <hr class="disclaimer-page-divider" />
      <p class="disclaimer-page-meta-date"><em>Last Updated: <strong>${lastUpdatedDate}</strong>. Copyright &copy; 2026 Nutrivio Medical Services Private Limited. All Rights Reserved.</em></p>
    `
  }
];

const SECTIONS_DATA = rawSections.map(s => ({
  ...s,
  id: `disclaimer-${s.id}`
}));

const Disclaimer = () => {
  const [openSections, setOpenSections] = useState([]);
  const [activeTocId, setActiveTocId] = useState(null);
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileSelectedId, setMobileSelectedId] = useState('all');
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);

  const sectionRefs = useRef({});
  const mobileNavRef = useRef(null);

  SECTIONS_DATA.forEach(section => {
    if (!sectionRefs.current[section.id]) {
      sectionRefs.current[section.id] = React.createRef();
    }
  });

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 160;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });
    }
  };

  const toggleSection = (id) => {
    setOpenSections(prev =>
      prev.includes(id) ? prev.filter(sid => sid !== id) : [...prev, id]
    );
  };

  const handleTocClick = (id) => {
    if (!openSections.includes(id)) {
      setOpenSections(prev => [...prev, id]);
    }
    setActiveTocId(id);
    scrollToSection(id);
  };

  const handleMobileSelect = (id) => {
    setMobileSelectedId(id);
    setActiveTocId(id === 'all' ? SECTIONS_DATA[0].id : id);

    if (id === 'all') {
      setOpenSections([SECTIONS_DATA[0].id]);
      scrollToSection(SECTIONS_DATA[0].id);
    } else {
      setOpenSections([id]);
      scrollToSection(id);
    }
    setIsMobileNavOpen(false);
  };

  const handleScroll = useCallback(() => {
    setShowBackToTop(window.scrollY > 350);

    let currentActiveId = null;
    const headerOffset = 170;

    const sectionsInView = SECTIONS_DATA.filter(s =>
      s.title.toLowerCase().includes(searchTerm.toLowerCase())
    );

    for (let i = sectionsInView.length - 1; i >= 0; i--) {
      const section = sectionsInView[i];
      const element = document.getElementById(section.id);
      if (element) {
        const rect = element.getBoundingClientRect();
        if (rect.top <= headerOffset) {
          currentActiveId = section.id;
          break;
        }
      }
    }

    if (currentActiveId) {
      setActiveTocId(currentActiveId);
    }
  }, [searchTerm]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (SECTIONS_DATA.length > 0) {
      setOpenSections(SECTIONS_DATA.map(s => s.id));
      setActiveTocId(SECTIONS_DATA[0].id);
    }

    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const filteredSections = SECTIONS_DATA.filter(s =>
    s.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sectionsToRender = (mobileSelectedId !== 'all')
    ? filteredSections.filter(s => s.id === mobileSelectedId)
    : filteredSections;

  return (
    <div className="disclaimer-page-wrapper">
      
      {/* Sticky Subheader & Breadcrumbs */}
      <div className="disclaimer-page-subheader">
        <div className="disclaimer-page-subheader-inner">
          <nav aria-label="Breadcrumb" className="disclaimer-page-breadcrumbs">
            <ol>
              <li><a href="/">Home</a></li>
              <li><span className="disclaimer-page-sep">›</span><span aria-current="page">Disclaimer</span></li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Main Layout */}
      <div className="disclaimer-page-container">
        <div className="disclaimer-page-layout">
          
          {/* ================= LEFT SIDEBAR ================= */}
          <aside className="disclaimer-page-sidebar">
            <div className="disclaimer-page-toc-card">
              
              {/* Search Box */}
              <div className="disclaimer-page-search-box">
                <div className="disclaimer-page-search-wrap">
                  {ICONS.SEARCH}
                  <input
                    type="search"
                    placeholder="Search disclaimer sections..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="disclaimer-page-search-input"
                    aria-label="Filter disclaimer sections"
                  />
                </div>
              </div>

              {/* Mobile Selector */}
              <div className="disclaimer-page-mobile-dropdown" ref={mobileNavRef}>
                <button
                  type="button"
                  className="disclaimer-page-mobile-toggle-btn"
                  onClick={() => setIsMobileNavOpen(!isMobileNavOpen)}
                >
                  <span>{mobileSelectedId === 'all' ? 'All Disclaimer Sections' : filteredSections.find(s => s.id === mobileSelectedId)?.title}</span>
                  <span className={`disclaimer-page-select-arrow ${isMobileNavOpen ? 'open' : ''}`}>▼</span>
                </button>
                {isMobileNavOpen && (
                  <ul className="disclaimer-page-mobile-listbox">
                    <li 
                      className={mobileSelectedId === 'all' ? 'active' : ''}
                      onClick={() => handleMobileSelect('all')}
                    >
                      All Disclaimer Sections
                    </li>
                    {filteredSections.map(s => (
                      <li 
                        key={s.id}
                        className={mobileSelectedId === s.id ? 'active' : ''}
                        onClick={() => handleMobileSelect(s.id)}
                      >
                        {s.title}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Desktop TOC */}
              <nav className="disclaimer-page-desktop-toc">
                <h3 className="disclaimer-page-toc-heading">Governance Clauses</h3>
                <ul className="disclaimer-page-toc-list">
                  {filteredSections.map(s => (
                    <li key={s.id} className={`disclaimer-page-toc-item ${activeTocId === s.id ? 'active' : ''}`}>
                      <a
                        href={`#${s.id}`}
                        onClick={(e) => { e.preventDefault(); handleTocClick(s.id); }}
                        className="disclaimer-page-toc-link"
                      >
                        <span className="disclaimer-page-toc-num">{s.num}</span>
                        <span className="disclaimer-page-toc-text">{s.title}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>

              {/* Regulatory Notice Seal */}
              <div className="disclaimer-page-sidebar-trust-box">
                <div className="disclaimer-page-trust-icon">
                  {ICONS.SHIELD_ALERT}
                </div>
                <div>
                  <strong>Independent Capacity</strong>
                  <p>Independent professional services with zero regulatory guarantees or liaison claims.</p>
                </div>
              </div>

            </div>
          </aside>

          {/* ================= MAIN CONTENT ================= */}
          <main className="disclaimer-page-main-content">
            {sectionsToRender.length > 0 ? (
              sectionsToRender.map(section => {
                const isOpen = openSections.includes(section.id);
                return (
                  <div 
                    key={section.id} 
                    id={section.id} 
                    className="disclaimer-page-card"
                    ref={sectionRefs.current[section.id]}
                  >
                    <button
                      type="button"
                      className="disclaimer-page-card-header"
                      onClick={() => toggleSection(section.id)}
                      aria-expanded={isOpen}
                    >
                      <div className="disclaimer-page-card-title-wrap">
                        <span className="disclaimer-page-card-icon">{section.icon}</span>
                        <h2 className="disclaimer-page-card-title">{section.title}</h2>
                      </div>
                      <span className={`disclaimer-page-chevron ${isOpen ? 'open' : ''}`}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                          <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                      </span>
                    </button>

                    {isOpen && (
                      <div 
                        className="disclaimer-page-card-body" 
                        dangerouslySetInnerHTML={{ __html: section.content }} 
                      />
                    )}
                  </div>
                );
              })
            ) : (
              <div className="disclaimer-page-no-results">
                <h3>No Matching Topics</h3>
                <p>No disclaimer clauses match "<strong>{searchTerm}</strong>". Please clear your search query.</p>
              </div>
            )}
          </main>

        </div>
      </div>

      {/* Floating Back to Top */}
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className={`disclaimer-page-back-to-top ${showBackToTop ? 'visible' : ''}`}
        aria-label="Back to top"
      >
        {ICONS.ARROW_UP}
      </button>

    </div>
  );
};

export default Disclaimer;